module.exports = __webpack_public_path__ + "static/media/PM GATISHAKTI NPG.bb2d41e0.svg";